export default {
  name: 'teaser-card',
  components: {},
  props: {
    service: Object
  },
  data() {
    return {

    }
  },
  computed: {

  },
  mounted() {

  },
  methods: {

  }
}